import createAction from 'redux-actions/es/createAction';

export const apiCallCounterInc = createAction('API_CALL_COUNTER_INC');
export const apiCallCounterDec = createAction('API_CALL_COUNTER_DEC');
